// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnFiller_root__1Vctc"};